<div class="d-flex flex-column h-100">
    <div class="d-flex w-100">
        <telxl-search
            [searchText]="searchText()"
            [disabled]="disabled()"
            (searchTextChange)="searchChanged($event)"
            id="active-agent-directory-search"
            class="w-100"
        ></telxl-search>
        @if (showPresenceFilter()) {
            <div class="ms-2">
                <telxl-dropdown
                    size="sm"
                    colour="dropdown"
                    [outline]="true"
                    position="bottom-end"
                    [menuItems]="presenceMenuItems"
                    [disabled]="disabled()"
                    [selected]="presence"
                    (selectedChange)="presence = $event"
                />
            </div>
        }
    </div>
    <div
        class="scroll-container mt-2"
        [ngClass]="{ 'h-100': calculateHeight() === null }"
        [style.height]="calculateHeight()"
        [style.max-height]="calculateHeight()"
    >
        @for (listing of listings(); track listing.id) {
            <telxl-shared-directory-listing-item
                source="internal-directory"
                view="presence"
                [customButtonTemplate]="customButtonTemplate()"
                [item]="listing"
                [mode]="mode()"
                [highlight]="highlight() === listing.id"
                [displayMediaIcons]="displayMediaIcons()"
                [disabled]="disabled()"
                [selected]="{
                    item: selected()?.item ?? [],
                    selected: selected()?.id === listing.id,
                }"
                (selectedChange)="selectedChanged($event)"
            />
        } @empty {
            @if (!isLoading()) {
                <div
                    class="d-flex flex-column align-items-center justify-content-center h-100"
                >
                    <i class="fa-thin fa-face-zipper text-primary"></i>
                    <div class="font-xxl mt-4">No data!</div>
                    <div class="mt-4">No agents were found.</div>
                </div>
            } @else {
                <div class="h-100 w-100">
                    <telxl-loading size="3rem" />
                </div>
            }
        }
    </div>
</div>
